import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5ae8622b&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=5ae8622b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8622b",
  null
  
)

export default component.exports